import React from 'react';
import classNames from 'classnames';

// Types
import { TypographyProps } from '../../types/typography/typography';

export const Typography = ({
  id,
  size,
  stack,
  casing,
  weight,
  margin,
  padding,
  addFlow,
  spacing,
  utility,
  children,
  addBlock,
  hasError,
  isItalics,
  alignment,
  component,
  className,
  addSrOnly,
  decoration,
  fontColour,
}: TypographyProps) => {
  const Component = component;

  const classnames = classNames({
    flow: addFlow,
    block: addBlock,
    [`${size}`]: size,
    [`${stack}`]: stack,
    'sr-only': addSrOnly,
    'has-error': hasError,
    [`${casing}`]: casing,
    [`${weight}`]: weight,
    [`${spacing}`]: spacing,
    [`${utility}`]: utility,
    'font-italic': isItalics,
    [`${className}`]: className,
    [`${decoration}`]: decoration,
    [`${fontColour}`]: fontColour,
    [`${alignment?.toString().replaceAll(',', ' ')}`]: alignment,

    [`${margin?.m}`]: margin?.m,
    [`${margin?.mb}`]: margin?.mb,
    [`${margin?.ml}`]: margin?.ml,
    [`${margin?.mr}`]: margin?.mr,
    [`${margin?.mt}`]: margin?.mt,
    [`${margin?.my}`]: margin?.my,
    [`${margin?.mx}`]: margin?.mx,

    [`${padding?.p}`]: padding?.p,
    [`${padding?.pb}`]: padding?.pb,
    [`${padding?.pl}`]: padding?.pl,
    [`${padding?.pr}`]: padding?.pr,
    [`${padding?.pt}`]: padding?.pt,
    [`${padding?.py}`]: padding?.py,
    [`${padding?.px}`]: padding?.px,
  });

  return (
    <Component id={id} className={classnames}>
      {children}
    </Component>
  );
};
